import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../../Components/Admin/assets/icons/a1.png";
import colunms from "../../../../Components/Admin/assets/icons/LINES.png";
import search1 from "../../../../Components/Admin/assets/icons/search.png";
import top from "../../../../Components/Admin/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faRotate, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../../common/ModalDelete";
import { AddButton, EditButton, DeletButton } from "../../../common/Button";
import { CommonIds } from "../../../../utils/common";
import { postData } from "../../../../utils/api";
import BankDetails from "./BankDetails";

library.add(fas);

// *****************************************************************************************************

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    IMG_URL,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [changeMaintainStatus, setChangeMaintainStatus] = useState();
  const [changeMTW, setChangeMTW] = useState();
  const [option, setOption] = useState();

  const getDataAll = async () => {
    const response = await getData(
      `/masters/app-setup?page=${currentPage}&per_page=${perPage}&term=${search}`,
    );
    await setData(response);
    setCurrentPage(response?.data?.currentPage);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);

    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));

    const newData = response?.data?.data;
    if (newData) {
      const newIds = newData.map((d) => d?.id);
      setAllChecked(newIds);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, changeMaintainStatus]);

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/masters/app-setup/${id}`);
    setChangeStatus(response);
  };

  const ChangeMaintainStatus = async (id) => {
    const response = await editStatusData(
      `/investors/investors/maintain-status/${id}`,
    );
    setChangeMaintainStatus(response);
  };

  const ChangeMTWithdrwalStatus = async (id) => {
    const response = await editStatusData(
      `/investors/investors/mt-withdrwal-status/${id}`,
    );
    setChangeMaintainStatus(response);
  };

  const ChangeMTTradeStatus = async (id) => {
    const response = await editStatusData(
      `/investors/investors/mt-trade-status/${id}`,
    );
    setChangeMaintainStatus(response);
  };

  const ChangeAllowDepositStatus = async (id) => {
    const response = await editStatusData(
      `/investors/investors/allow-deposit-status/${id}`,
    );
    getDataAll();
  };

  const ChangeAllowWithdrawalStatus = async (id) => {
    const response = await editStatusData(
      `/investors/investors/allow-withdrawal-status/${id}`,
    );
    getDataAll();
  };

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Select All Functionality
  const [selectAllChecked, setSelectAllChecked] = useState([]);
  const [allChecked, setAllChecked] = useState([]);

  const handleSelectAll = async () => {
    await setSelectAllChecked(allChecked);
  };

  const handleChange = async (e) => {
    const { value, checked } = e.target;

    if (value === "selectAll") {
      if (checked) {
        handleSelectAll();
      } else {
        await setSelectAllChecked([]);
      }
    } else {
      if (checked) {
        await setSelectAllChecked([...selectAllChecked, Number(value)]);
      } else {
        await setSelectAllChecked(
          selectAllChecked.filter((e) => e !== Number(value)),
        );
      }
    }
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(
        `/masters/app-setup/${recordToDeleteId}`,
      );

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
    col7: true,
    col8: true,
    col9: true,
    col10: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  return (
    <>
      <div className="main-advancedashboard addasbordssd">
        <Header title={"App Setup"} link={"/masters/app-setup"} />
        <section className="Advancemain-advancedashboard">
          <div className="col-xxl-12 col-xl-12  ">
            <section className="Tabels tab-radio tab-radio mt-3">
              <div className="">
                <div className="row">
                  <div className="d-flex">
                    <div className="add me-3">
                      {/* <Link type="button" className="btn btn-add pe-3">
                        <div onClick={() => handleShow()}>
                          <img src={plus} className="plus me-2 ms-0" alt="" />
                          Add App Setup
                        </div>
                      </Link> */}
                      {/* {isAllow.includes(10) ? (
                       
                      ) : (
                        <></>
                      )} */}
                    </div>
                  </div>
                  <div className="row ">
                    <div className=" col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-12 my-auto">
                      <div className="d-flex">
                        <div className="show me-2">
                          <p className="show mt-1">Show</p>
                        </div>
                        <div className="number me-2">
                          <select
                            className="form-select form-select-sm"
                            aria-label=".form-select-sm example"
                            onChange={(e) => setperPage(e.target.value)}
                          >
                            {option?.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="entries">
                          <p className="show mt-1">entries</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xxl-9   col-xl-9 col-lg-9  col-md-12 col-12 my-auto">
                      <div className="d-flex justify-content-end">
                        <div className="sowing me-2">
                          <p className="show mt-2">{`Showing ${Math.min(
                            (currentPage - 1) * perPage + 1,
                          )} to ${Math.min(
                            currentPage * perPage,
                            data?.data?.totalEntries,
                          )} of ${data?.data?.totalEntries} entries`}</p>
                        </div>
                        <div className="num me-2">
                          <input
                            type="text"
                            className="form-control"
                            id=""
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                          />
                        </div>
                        <div className="Search me-2">
                          <button
                            type="button"
                            onClick={getDataAll}
                            className="btn btn-search"
                          >
                            <img src={search1} className="search" alt="" />
                          </button>
                        </div>

                        <div className="Search-1">
                          <button
                            type="button"
                            onClick={() => {
                              setSearch("");
                              setReset(!reset);
                            }}
                            className="btn btn-reset"
                          >
                            <FontAwesomeIcon icon={faRotate} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="border-line mt-2"></div>
                <div className="row mt-3">
                  <div className="data table-responsive">
                    <Table striped bordered hover responsive center>
                      <thead>
                        <tr className="">
                          {visible.col1 && (
                            <th className="tax-name">Sr. No.</th>
                          )}
                          {/* {visible.col2 && (
                            <th className="tax-name">UPI ID </th>
                          )}
                          {visible.col5 && (
                            <th className="tax-name">A/c No </th>
                          )} */}

                          {/* <th className="tax-name">Operator Charges</th> */}
                          <th className="tax-name">App Version</th>
                          <th className="tax-name">Mini Withdrawn</th>
                          {visible.col6 && (
                            <th className="tax-name">AI Status</th>
                          )}
                          {visible.col7 && (
                            <th className="tax-name">Maintainance Status</th>
                          )}
                          {visible.col8 && (
                            <th className="tax-name">MT Withdrawal Status</th>
                          )}
                          {visible.col10 && (
                            <th className="tax-name">MT Trade Status</th>
                          )}
                          {/* {visible.col8 && <th className="tax-name">Allow Deposit</th>}
                          {visible.col9 && <th className="tax-name">Allow Withdrawal</th>} */}
                          {visible.col4 && <th className="active">Action</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.data?.map((d, index) => {
                          return (
                            <tr className="" key={index}>
                              {visible.col1 && <td>{++index}.</td>}
                              {visible.col2 && <td>{d?.app_version}</td>}
                              {/* {visible.col5 && <td>{d?.ac_no}</td>} */}
                              {/* <td>{d?.operator_charges}</td> */}
                              {/* <td>{d?.refer_percentage}</td> */}
                              <td>{d?.mini_withdrawn}</td>
                              {visible.col6 && (
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={d.setting}
                                      disabled={!isAllow?.includes(12)}
                                      onChange={() => {
                                        ChangeStatus(d.id);
                                      }}
                                      id={`flexSwitchCheckDefault${d?.id}`}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`flexSwitchCheckDefault${d?.id}`}
                                    >
                                      {d.setting ? "Active" : "Inactive"}
                                    </label>
                                  </div>
                                </td>
                              )}
                              {visible.col7 && (
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={d.maintainance}
                                      disabled={!isAllow?.includes(12)}
                                      onChange={() => {
                                        ChangeMaintainStatus(d.id);
                                      }}
                                      id={`maintainance${d?.id}`}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`maintainance${d?.id}`}
                                    >
                                      {d.maintainance ? "Active" : "Inactive"}
                                    </label>
                                  </div>
                                </td>
                              )}{" "}
                              {visible.col8 && (
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={d?.mt_withdrwal_status}
                                      disabled={!isAllow?.includes(12)}
                                      onChange={() => {
                                        ChangeMTWithdrwalStatus(d.id);
                                      }}
                                      id={`mt_withdrwal_status${d?.id}`}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`mt_withdrwal_status${d?.id}`}
                                    >
                                      {d?.mt_withdrwal_status
                                        ? "Active"
                                        : "Inactive"}
                                    </label>
                                  </div>
                                </td>
                              )}
                              {visible.col10 && (
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={d?.mt_trade_status}
                                      disabled={!isAllow?.includes(12)}
                                      onChange={() => {
                                        ChangeMTTradeStatus(d.id);
                                      }}
                                      id={`mt_trade_status${d?.id}`}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`mt_trade_status${d?.id}`}
                                    >
                                      {d?.mt_trade_status
                                        ? "Active"
                                        : "Inactive"}
                                    </label>
                                  </div>
                                </td>
                              )}
                              {/* {visible.col8 && (
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={d.allow_deposit}
                                      disabled={!isAllow?.includes(12)}
                                      onChange={() => {
                                        ChangeAllowDepositStatus(d.id);
                                      }}
                                      id={`allow_deposit${d?.id}`}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`allow_deposit${d?.id}`}
                                    >
                                      {d.allow_deposit ? "Active" : "Inactive"}
                                    </label>
                                  </div>
                                </td>
                              )}
                              {visible.col9 && (
                                <td>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={d.allow_withdrawal}
                                      disabled={!isAllow?.includes(12)}
                                      onChange={() => {
                                        ChangeAllowWithdrawalStatus(d.id);
                                      }}
                                      id={`allow_withdrawal${d?.id}`}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`allow_withdrawal${d?.id}`}
                                    >
                                      {d.allow_withdrawal
                                        ? "Active"
                                        : "Inactive"}
                                    </label>
                                  </div>
                                </td>
                              )} */}
                              {visible.col4 && (
                                <td>
                                  <div className="d-flex">
                                    {isAllow?.includes(11) ? (
                                      <EditButton
                                        handleShow1={handleShow1}
                                        id={d?.id}
                                      />
                                    ) : (
                                      <></>
                                    )}

                                    {/* <DeletButton
                                      showDeleteRecord={showDeleteRecord}
                                      id={d?.id}
                                      name={d?.name}
                                    /> */}
                                  </div>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                </div>
                <BankDetails />
              </div>
            </section>
          </div>
        </section>
      </div>

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}
      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
